<template>
    <div class="relative">
        <div
            class="flex flex-col lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:items-center lg:gap-24"
        >
            <div
                class="mt-12 sm:mt-16 lg:mt-0"
                :class="[shouldShowImageFirst ? 'order-2 lg:order-1' : 'order-2']"
            >
                <div class="img-box">
                    <img v-if="image" :src="require('./assets/' + image)" alt="step1" />

                    <div v-if="videoId" class="video-box">
                        <iframe
                            class="hidden absolute top-0 left-0 w-full h-full"
                            width="100%"
                            height="100%"
                            :src="`https://www.youtube.com/embed/${videoId}`"
                        ></iframe>
                    </div>
                    <div
                        v-if="videoId"
                        :data-video-id="videoId"
                        @click="showVideo"
                        class="video-thumbnail cursor-pointer group absolute top-0 left-0 w-full h-full flex items-center justify-center"
                    >
                        <img
                            class="absolute top-0 left-0 w-full h-full object-cover"
                            :src="`https://img.youtube.com/vi/${videoId}/0.jpg`"
                        />
                        <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>

                        <ButtonPlay
                            class="absolute transition-opacity opacity-50 group-hover:opacity-100"
                        />
                    </div>
                </div>
            </div>
            <div
                class="px-4 max-w-xl mx-auto sm:px-6 py-16 lg:max-w-none lg:mx-0 lg:px-0"
                :class="[shouldShowImageFirst ? 'order-1 lg:order-2' : 'order-1']"
            >
                <div>
                    <div>
                        <span
                            class="relative text-white bg-cookie-500 font-semibold text-xl h-12 w-12 rounded-full flex items-center justify-center"
                            >{{ point }}</span
                        >
                    </div>
                    <div class="mt-6 space-y-4">
                        <h2 class="text-lg font-bold ct-text-1">
                            {{ title }}
                        </h2>
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ButtonPlay } from "@easy/ui/buttons";

export default {
    name: "InfoPoint",
    props: {
        point: Number,
        title: String,
        image: String,
        videoId: String,
    },
    computed: {
        shouldShowImageFirst() {
            return this.point % 2 === 0;
        },
    },
    components: {
        ButtonPlay,
    },
    methods: {
        showVideo(e) {
            const element = e.target.closest(".img-box");
            const videoThumbnail = element.querySelector(".video-thumbnail");
            const videoId = videoThumbnail.dataset.videoId;
            const videoBoxIframe = element.querySelector(".video-box iframe");
            videoBoxIframe.classList.remove("hidden");
            videoThumbnail.classList.add("hidden");
            videoBoxIframe.src =
                "https://www.youtube.com/embed/" + videoId + "?enablejsapi&autoplay=1";
        },
    },
};
</script>

<style lang="scss" scoped>
.img-box {
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (min-width: 1024px) {
        height: 100%;
    }
}
.video-box {
    width: 100%;
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
}
img {
    max-width: 100%;
}
</style>
